<div class="tiers-container" fxLayout="column" fxLayoutAlign="center center">
  <!-- <ng-container *ngIf="isTiered; else nonTieredLayout"> -->
    <ng-container *ngIf="isTiered">
    <div class="shop-page-heading shop-page-heading--center">
      <div class="shop-page-heading__copy">
        <h1 class="shop-page-heading__title">{{ 'CHOOSE_YOUR_SERVICE_TIER' | translate }}</h1>
        <p class="shop-page-heading__subtitle">{{ 'SELECT_THE_TIER_THAT_BEST_FITS_YOUR_NEEDS' | translate }}*</p>
      </div>
    </div>

    <div class="pricing-table" fxLayout="row" fxLayoutAlign="center stretch" >
      <ng-container *ngFor="let tier of pricingTiers">
        <div class="pricing-card" *ngIf="tieredProducts.includes(tier.name)">
          <h2 class="tier-name">{{ tier.name | translate }}</h2>
          <p class="tier-description">{{ tier.description | translate }}</p>
          <div class="tier-price" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
            <div class="price-column" *ngIf="tier.singlePrice !== null && tier.singlePrice > 0">
              <div class="price-platform">{{ 'SINGLE_PLATFORM' | translate }}</div>
              <div class="price-line">
                <span class="price">{{ tier.singlePrice | currency:'USD':'symbol':'1.0-0' }}</span>
                <span class="per-month">{{ 'PER_MONTH' | translate }}</span>
              </div>
              <div *ngIf="hasSetup" class="signup-fee">
                <ng-container *ngIf="tier.singleSignupFee !== null && tier.singleSignupFee > 0; else noSingleSignupFee">+{{ tier.singleSignupFee | currency:'USD':'symbol':'1.0-0' }}</ng-container>
                <ng-template #noSingleSignupFee>{{ 'NO' | translate }}</ng-template>
                {{ 'SETUP_FEE' | translate }}
              </div>
            </div>
            <div class="price-column" *ngIf="tier.multiPrice !== null && tier.multiPrice > 0">
              <div class="price-platform">{{ 'MULTI_PLATFORM' | translate }}</div>
              <div class="price-line">
                <span class="price">{{ tier.multiPrice | currency:'USD':'symbol':'1.0-0' }}</span>
                <span class="per-month">{{ 'PER_MONTH' | translate }}</span>
              </div>
              <div *ngIf="hasSetup" class="signup-fee">
                <ng-container *ngIf="tier.multiSignupFee !== null && tier.multiSignupFee > 0; else noMultiSignupFee">+{{ tier.multiSignupFee | currency:'USD':'symbol':'1.0-0' }}</ng-container>
                <ng-template #noMultiSignupFee>{{ 'NO' | translate }}</ng-template>
                {{ 'SETUP_FEE' | translate }}
              </div>
            </div>
          </div>
          <ul class="features-list">
            <li *ngFor="let feature of featureKeys">
              <mat-icon class="feature-icon" [ngClass]="tier.features[feature] ? 'check-icon' : 'x-icon'">
                {{ tier.features[feature] ? 'check_circle' : 'cancel' }}
              </mat-icon>
              <span class="feature-label">{{ getFeatureLabel(tier, feature) | translate }}</span>
              <ng-container *ngIf="getFeatureDescription(tier, feature) as desc; else noDesc">
                <mat-icon
                  class="feature-info-icon"
                  [matTooltip]="desc | translate"
                  matTooltipClass="shop-feature-tooltip"
                  matTooltipPosition="above"
                  [attr.aria-label]="'DETAILS' | translate"
                >info</mat-icon>
              </ng-container>

              <ng-template #noDesc>
                <span class="feature-info-icon-spacer" aria-hidden="true"></span>
              </ng-template>
            </li>
          </ul>
          <button
            class="blue-button tier-select-button"
            (click)="selectTier(tier)"
            [disabled]="existingSubscriptionTier && tier.id !== existingSubscriptionTier"
          >
            {{ 'SELECT_PLAN' | translate }}
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="companyProducts.length > 0">
        <div class="pricing-card pricing-card--other" fxLayout="column" fxLayoutAlign="space-between stretch">
          <div class="pricing-card__content">
            <h2 class="tier-name">{{ 'OTHER_PRODUCTS' | translate }}</h2>
            <p class="tier-description">{{ 'ADDITIONAL_SERVICES_WE_PROVIDE' | translate }}</p>
            <div *ngFor="let other of companyProducts" class="other-product-item">
              <h5 class="other-product-item__title">{{ other.display }}</h5>
              <p class="tier-description other-product-item__description">{{ other.description }}</p>
            </div>
          </div>
          <button class="blue-button tier-select-button" (click)="selectTier({ id: 0 })">{{ 'VIEW_PRODUCTS' | translate }}</button>
        </div>
      </ng-container>
    </div>
    <p class="tiers-footnote">* {{ 'TIER_SELECTED_APPLIES_TO_ALL_CAMPAIGNS' | translate }}</p>
  </ng-container>
</div>
